import React, { useEffect, useState } from "react";
import { db, collection, onSnapshot, query, where } from "../boardData";
import { WidgetShell, EmptyState } from "./common";

// Personnel currently on duty for this agency (OndutyFire / OndutyEMS flags).
const DutyCrewWidget = ({ config = {}, agency }) => {
  const [crew, setCrew] = useState([]);

  useEffect(() => {
    if (!agency) return undefined;
    const unsub = onSnapshot(
      query(collection(db, "users"), where("agency", "==", agency)),
      (snap) => {
        const list = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((u) => u.OndutyFire || u.OndutyEMS || u.onDuty)
          .sort((a, b) => String(a.lastName || a.name || "").localeCompare(String(b.lastName || b.name || "")));
        setCrew(list);
      },
      (err) => console.warn("duty crew load failed", err)
    );
    return () => unsub();
  }, [agency]);

  const fullName = (u) =>
    u.name || [u.firstName, u.lastName].filter(Boolean).join(" ") || u.email || "Member";

  return (
    <WidgetShell title={`On Duty${crew.length ? ` · ${crew.length}` : ""}`}>
      {crew.length === 0 ? (
        <EmptyState icon="👤" label="No one currently on duty." />
      ) : (
        <div className="sb-duty-list">
          {crew.map((u) => (
            <div className="sb-duty-row" key={u.id}>
              <span className="sb-duty-name">{fullName(u)}</span>
              <span className="sb-duty-tags">
                {u.OndutyFire && <span className="sb-tag fire">FIRE</span>}
                {u.OndutyEMS && <span className="sb-tag ems">EMS</span>}
                {u.rank && <span className="sb-duty-rank">{u.rank}</span>}
              </span>
            </div>
          ))}
        </div>
      )}
    </WidgetShell>
  );
};

export default DutyCrewWidget;
